import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, switchMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthenticationHttpInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthenticationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('Http error has been detected', error);
        console.log('Error status:', error.status);
        console.log('Error statusText:', error.statusText);
        console.log('Error type:', error.error?.constructor?.name);

        // Status 0 with "Unknown Error" often indicates a CORS-blocked response
        // When the server returns 401 without proper CORS headers, the browser
        // blocks JavaScript from reading the actual status code
        const isUnauthorized = error.status === HttpStatusCode.Unauthorized;
        const hasAuthHeader = req.headers.has('Authorization');
        const isPossibleCorsBlocked401 =
          error.status === 0 &&
          error.statusText === 'Unknown Error' &&
          hasAuthHeader;

        if (isUnauthorized || isPossibleCorsBlocked401) {
          console.log(
            'Http error is unauthorized (or CORS-blocked 401)',
            error,
          );
          return of(this.authService.updateSession()).pipe(
            switchMap(() => this.authService.session),
            switchMap(session => {
              const token = session.getIdToken().getJwtToken();
              console.log('newToken', token);
              const updatedRequest = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
              });
              return next.handle(updatedRequest);
            }),
          );
        }

        return throwError(() => error);
      }),
    );
  }
}
